import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { ValueWithRandom } from "../../../ValueWithRandom";
import { deepExtend } from "../../../../../Utils/Utils";
export var MovePath = /*#__PURE__*/function () {
  function MovePath() {
    _classCallCheck(this, MovePath);

    this.clamp = true;
    this.delay = new ValueWithRandom();
    this.enable = false;
    this.options = {};
  }

  _createClass(MovePath, [{
    key: "load",
    value: function load(data) {
      if (!data) {
        return;
      }

      if (data.clamp !== undefined) {
        this.clamp = data.clamp;
      }

      this.delay.load(data.delay);

      if (data.enable !== undefined) {
        this.enable = data.enable;
      }

      this.generator = data.generator;

      if (data.options) {
        this.options = deepExtend(this.options, data.options);
      }
    }
  }]);

  return MovePath;
}();